import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  ACCOUNTS_MENU: `${cleanedFilename(__filename)}-accounts-menu`,
};
